import { useDispatch, useSelector } from "react-redux";
import { profileActions } from "@/redux/profile/actions";
import { profileSelectors } from "@/redux/profile/selectors";

export interface YearSelection {
  year: number;
  handleYearChange: (year: number) => void;
}

export const useStatisticsYearSelect = (): YearSelection => {
  const { currentYear } = useSelector(profileSelectors.getGlobal);
  const dispatch = useDispatch();

  const handleYearChange = (selectedYear: number) => {
    dispatch(
      profileActions.setGlobalState({
        currentYear: selectedYear,
      })
    );
  };

  return {
    year: currentYear,
    handleYearChange,
  };
};
